module.exports = "<div class=\"input-option\">\n  <p-autoComplete (completeMethod)=\"search($event)\" [suggestions]=\"results\" [(ngModel)]=\"inputText\" name=\"inputText\" (keyup)=\"getInputText()\"\n    [placeholder]=\"placeHolder\"></p-autoComplete>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /data/wwwroot/xzhipin/app-client/src/app/user/input-option/input-option.component.html
// module id = ../../../../../src/app/user/input-option/input-option.component.html
// module chunks = common